import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import GenericDialog from "../../../../../../../ui/dialogs/generic-dialog/GenericDialog";
import Grid from "@material-ui/core/Grid";
import {Button} from "@material-ui/core";

const KeepPasswordDialog = (props) => {
    const dialogContent = (
        <Typography variant="body2">
            Conserva la password che sarà necessaria agli utenti finali per aprire il PDF e scaricare il QR code
            contenuto nella email. Una volta chiusa la successiva schermata non potrai più recuperarla in
            quanto Fastweb non conserva la password
        </Typography>
    )

    const dialogActions = (
        <Grid container justifyContent="flex-end">
            <Button color="primary" variant="contained" onClick={props.handleDialogClose}>
                Avanti
            </Button>
        </Grid>
    )
    return (
        <GenericDialog
            dialogWidth="sm"
            open={props.open}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleDialogClose}
            dialogActions={dialogActions}
            dialogContent={dialogContent}
        >
            <Typography variant={"h6"}>
                ATTENZIONE
            </Typography>
        </GenericDialog>
    )
}

KeepPasswordDialog.propTypes = {
    handleDialogClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
}
export default KeepPasswordDialog